import { jsx as _jsx } from "react/jsx-runtime";
import { LoaderSize, Loader } from '@front-core/loader';
import styles from './layoutMap.scss';
const MapLoader = () => _jsx("div", { className: styles.mapLoader, "data-sentry-component": "MapLoader", "data-sentry-source-file": "loader.tsx", children: _jsx(Loader, { size: LoaderSize.ExtraLarge, "data-sentry-element": "Loader", "data-sentry-source-file": "loader.tsx" }) });
export default MapLoader;
